module.exports = __webpack_public_path__ + "static/media/DTUK-26-LOGO.8738ed80.png";